import {
  TextField,
  InputAdornment,
  MenuItem,
  stepButtonClasses,
  FormHelperText,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event";
import PaymentIcon from "@mui/icons-material/Payment";
import ArticleIcon from "@mui/icons-material/Article";
import { useState, useContext, useEffect } from "react";
import { ValTextAndNumber } from "../../../../../Validators/ValTextAndNumber";
import { ValIsEmail } from "../../../../../Validators/ValIsEmail";
import { ValPedidoDatosGenerales } from "./Validators/ValPedidoDatosGenerales";
import Swal from "sweetalert2";
import SaveIcon from "@mui/icons-material/Save";
import request from "../../../../../Helpers/API";
import { Context as PedidoContext } from "./DashPedidoMaquinariascreen";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../../../components/LoaderScreen";
import { ValSpecialCharacters } from "../../../../../Validators/ValSpecialCharacters";
import PersonIcon from "@mui/icons-material/Person";

const bError = false;
const initialstate = {
  rfc: "",
  correoelectronico: "",
  celular: "",
  domicilio: "",
  lugarentrega: "",
  fechaentrega: "",
  condiciones: "No Aplica",
  metodopago: "PPD",
  formapago: "99",
  usocfdi: "",
  tiporelacion: "",
  anticipos: "",
  folioanticipo: "",
  brfc: bError,
  bcorreoelectronico: bError,
  bcelular: bError,
  bdomicilio: bError,
  blugarentrega: bError,
  bfechaentrega: bError,
  bcondiciones: bError,
  bmetodopago: bError,
  bformapago: bError,
  busocfdi: bError,
  btiporelacion: bError,
  banticipos: bError,
  bfolioanticipo: bError,
  mrfc: bError,
  mcorreoelectronico: bError,
  mcelular: bError,
  mdomicilio: bError,
  mlugarentrega: bError,
  mfechaentrega: bError,
  mcondiciones: bError,
  mmetodopago: bError,
  mformapago: bError,
  musocfdi: bError,
  mtiporelacion: bError,
  manticipos: bError,
  mfolioanticipo: bError,
};

export default function DashPedidoMaquinariaDatosGenerales({
  setValue,
  setScreen,
  screen,
  setBottonguardar,
}) {
  const history = useHistory();
  const folio = useContext(PedidoContext);
  const [state, setState] = useState(initialstate);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const onChange = (prop, value, sbool, smensaje) => {
    setState({
      ...state,
      [prop]: value,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };
  const [activeField, setActiveField] = useState(null);

  const handleTextFieldFocus = (fieldName) => {
    setActiveField(fieldName); // Marcar el TextField como activo cuando se enfoca
  };

  const handleTextFieldBlur = () => {
    setActiveField(null); // Desactivar el TextField cuando pierde el foco
  };

  const onGuardar = async () => {
    setLoader({ ...loader, mostrar: true });
    var result = ValPedidoDatosGenerales(state);
    if (result.isValid === false) {
      setLoader({ ...loader, mostrar: false });
      await Swal.fire(
        "PEDIDO DE MAQUINARIA",
        JSON.stringify(result.mensaje),
        "error"
      );
    } else {
      result.post.folio = folio.state.folio;
      result.post.nombre_aval = state.nombre_aval;
      result.post.direccion_aval = state.direccion_aval;
      if (state.tipo_persona === "M") {
        if (
          result.post.nombre_aval === null ||
          result.post.nombre_aval === "" ||
          result.post.nombre_aval === undefined
        ) {
          Swal.fire({
            title: "PEDIDO DE MAQUINARIA",
            text: "Se debe de introducir el nombre del representante legal en el aval",
            icon: "error",
            customClass: {
              container: "mi-superpoop",
            },
          });
          setLoader({ ...loader, mostrar: false });
        } else if (
          result.post.direccion_aval === null ||
          result.post.direccion_aval === "" ||
          result.post.direccion_aval === undefined
        ) {
          Swal.fire({
            title: "PEDIDO DE MAQUINARIA",
            text: "Se debe de agregar la direccion del aval",
            icon: "error",
            customClass: {
              container: "mi-superpoop",
            },
          });
          setLoader({ ...loader, mostrar: false });
        } else {
          request
            .post("PedidoDatosGenerales", result.post)
            .then(async () => {
              setLoader({ ...loader, mostrar: false });
              await Swal.fire(
                "PEDIDO DE MAQUINARIA",
                "Datos guardados con exito",
                "success"
              );
              var habScreen = Number(screen) >= 2 ? screen : 1;
              setScreen(habScreen);
              setValue(1);
            })
            .catch((error) => {
              setLoader({ ...loader, mostrar: false });
              Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
            });
        }
      } else {
        request
          .post("PedidoDatosGenerales", result.post)
          .then(async () => {
            setLoader({ ...loader, mostrar: false });
            await Swal.fire(
              "PEDIDO DE MAQUINARIA",
              "Datos guardados con exito",
              "success"
            );
            var habScreen = Number(screen) >= 2 ? screen : 1;
            setScreen(habScreen);
            setValue(1);
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
          });
      }
    }
  };

  useEffect(() => {
    setBottonguardar(() => (
      <div
        onClick={() => onGuardar()}
        className="pedido-maquinaria-container-footer-guardar"
      >
        <SaveIcon /> Guardar y Continuar
      </div>
    ));
  }, [state]);
  useEffect(() => {
    if (
      folio.state.folio === undefined ||
      folio.state.folio === null ||
      folio.state.folio.length !== 13
    ) {
      history.push("/DashClientes/solicitudcreditoGenerar");
      return;
    }

    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoDatosGenerales/GetByFolio?folio=${folio.state.folio}`)
      .then((result) => {

        setState({
          ...state,
          celular: result.celular,
          correoelectronico: result.correoelectronico,
          fechaentrega: result.dfechaentrega,
          domicilio: result.domicilio,
          lugarentrega: result.lugarentrega,
          metodopago:
            result.metodopago !== undefined &&
              result.metodopago !== null &&
              result.metodopago !== ""
              ? result.metodopago
              : folio.state.tipo_solicitud === "C"
                ? "PUE"
                : "PPD",
          formapago:
            result.formapago !== undefined &&
              result.formapago !== null &&
              result.formapago !== ""
              ? result.formapago
              : folio.state.tipo_solicitud !== "C"
                ? "99"
                : "",
          usocfdi:
            result.usocfdi !== undefined &&
              result.usocfdi !== null &&
              result.usocfdi !== ""
              ? result.usocfdi
              : folio.state.tipo_solicitud === "J"
                ? "G01"
                : "I08",
          tiporelacion: result.tiporelacion,
          nombre_aval: result.nombre_aval,
          direccion_aval: result.direccion_aval,
          tipo_persona: result.tipo_persona,
          anticipos: result.anticipos,
          folioanticipo: result.foliosanticipos,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  }, []);

  return (
    <div className="pedido-maquinaria-grid-container">
      <LoaderScreen loader={loader} />
      <div className="pedido-maquinaria-correo-electronico">
        <TextField
          fullWidth
          size="small"
          label="Correo Electrónico"
          variant="outlined"
          className="cel-correo"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          type="text"
          error={state.bcorreoelectronico}
          onChange={({ target }) => {
            ValIsEmail("correoelectronico", target.value, onChange);
          }}
          onFocus={() => handleTextFieldFocus("correoelectronico")} // Manejar el foco del TextField
          onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
          value={state.correoelectronico}
        // helperText = "ejemplo@dominio.com"
        />
        {activeField === "correoelectronico" && (
          <FormHelperText
            id="cel-correo-helper-text"
            className="caracteres-especiales"
          >
            {"Formato: ejemplo@dominio.com"}
          </FormHelperText>
        )}
      </div>
      <TextField
        fullWidth
        size="small"
        label="Celular"
        variant="outlined"
        className="cel-celular"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PhoneIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="number"
        error={state.bcelular}
        onChange={({ target }) => {
          ValTextAndNumber("celular", target.value, onChange, true, 10);
        }}
        value={state.celular}
      />
      <TextField
        fullWidth
        size="small"
        label="Fecha de Entrega"
        type="date"
        variant="outlined"
        className="cel-5"
        InputLabelProps={{ shrink: true }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EventIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        error={state.bfechaentrega}
        onChange={({ target }) => {
          ValIsEmail("fechaentrega", target.value, onChange);
        }}
        value={state.fechaentrega}
      />
      <div className="pedido-maquinaria-domicilio">
        <TextField
          fullWidth
          size="small"
          label="Domicilio"
          variant="outlined"
          // className="cel-6"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <HomeIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          type="text"
          // helperText={state.mdomicilio}
          error={state.bdomicilio}
          onChange={({ target }) => {
            ValSpecialCharacters(
              "domicilio",
              target.value,
              onChange,
              true,
              100
            );
          }}
          onFocus={() => handleTextFieldFocus("domicilio")} // Manejar el foco del TextField
          onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
          value={state.domicilio}
        />
        {activeField === "domicilio" && (
          <FormHelperText className="caracteres-especiales">
            {"Puedes usar caracteres especiales como: $, #, . , y ñ."}
          </FormHelperText>
        )}
      </div>
      <div className="pedido-maquinaria-lugar-entrega">
        <TextField
          fullWidth
          size="small"
          label="Lugar de Entrega"
          variant="outlined"
          // className="cel-7"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocationOnIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          type="text"
          // helperText={state.mlugardeentrega}
          error={state.blugarentrega}
          onChange={({ target }) => {
            ValSpecialCharacters(
              "lugarentrega",
              target.value,
              onChange,
              true,
              100
            );
          }}
          onFocus={() => handleTextFieldFocus("lugarentrega")} // Manejar el foco del TextField
          onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
          value={state.lugarentrega}
        />
        {activeField === "lugarentrega" && (
          <FormHelperText className="caracteres-especiales">
            {"Puedes usar caracteres especiales como: $, #, . , y ñ."}
          </FormHelperText>
        )}
      </div>
      {/* <div className="pedido-maquinaria-condiciones">
        <TextField
          fullWidth
          size="small"
          label="CONDICIONES O MEDIDAS SOLICITADAS"
          variant="outlined"
          // className="cel-8"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ArticleIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          multiline={true}
          // maxRows={2}
          rows={2}
          type="text"
          error={state.bcondiciones}
          onChange={({ target }) => {
            ValSpecialCharacters(
              "condiciones",
              target.value,
              onChange,
              true,
              500
            );
          }}
          onFocus={() => handleTextFieldFocus('condiciones')} // Manejar el foco del TextField
          onBlur={handleTextFieldBlur} // Manejar la pérdida de foco del TextField
          value={state.condiciones}
        />
        {activeField === 'condiciones' && (
          <FormHelperText className="caracteres-especiales">
            {'Puedes usar caracteres especiales como: $, #, . , y ñ.'}
          </FormHelperText>
        )}
      </div> */}
      <TextField
        fullWidth
        disabled="true"
        size="small"
        label="Método de Pago"
        variant="outlined"
        className="cel-9"
        select
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PaymentIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        // helperText={state.msolicitante}
        error={state.bmetodopago}
        onChange={({ target }) => {
          setState({
            ...state,
            metodopago: target.value,
            bmetodopago: false,
          });
        }}
        value={state.metodopago}
      >
        <MenuItem value={"PPD"}>Pago en parcialidades o diferido</MenuItem>
        <MenuItem value={"PUE"}>Pago en una sola exhibición</MenuItem>
      </TextField>
      <TextField
        fullWidth
        disabled={folio.state.tipo_solicitud !== "C" ? "true" : ""}
        size="small"
        label="Forma de Pago"
        variant="outlined"
        className="cel-10"
        select
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PaymentIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        // helperText={state.msolicitante}
        error={state.bformapago}
        onChange={({ target }) => {
          setState({ ...state, formapago: target.value, bformapago: false });
        }}
        value={state.formapago}
      >
        <MenuItem value={"99"}>Por Definir</MenuItem>
        <MenuItem value={"01"}>Efectivo</MenuItem>
        <MenuItem value={"04"}>Tarjeta de Crédito</MenuItem>
        <MenuItem value={"28"}>Tarjeta de Debito</MenuItem>
        <MenuItem value={"05"}>Monedero Electronico</MenuItem>
        <MenuItem value={"02"}>Cheque Nominativo</MenuItem>
        <MenuItem value={"03"}>Transferencia Electronica de Fondos</MenuItem>
      </TextField>
      <TextField
        fullWidth
        size="small"
        label="Uso CFDI"
        variant="outlined"
        className="cel-11"
        select
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PaymentIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        error={state.busocfdi}
        onChange={({ target }) => {
          setState({ ...state, usocfdi: target.value, busocfdi: false });
        }}
        value={state.usocfdi}
      >
        <MenuItem value={"G01"}>Adquisición de Mercancias</MenuItem>
        <MenuItem value={"G03"}>Gastos en General</MenuItem>
        <MenuItem value={"I03"}>Equipo de transporte</MenuItem>
        <MenuItem value={"I07"}>Comunicaciones Satelitales</MenuItem>
        <MenuItem value={"I08"}>Otra Maquinaria y Equipo</MenuItem>
        <MenuItem value={"S01"}>Sin Obligaciones Fiscales</MenuItem>
      </TextField>
      <TextField
        fullWidth
        size="small"
        label="Tipos de Relación"
        variant="outlined"
        className="cel-12"
        select
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PaymentIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        error={state.btiporelacion}
        onChange={({ target }) => {
          setState({
            ...state,
            tiporelacion: target.value,
            btiporelacion: false,
          });
        }}
        value={state.tiporelacion}
      >
        <MenuItem value={"01"}>Nota de los Documentos Relacionados</MenuItem>
        <MenuItem value={"03"}>
          {" "}
          Devolución de Mercancia Sobre Facturas o Traslados Previos
        </MenuItem>
        <MenuItem value={"04"}>Sustitución de los CFDI Previos</MenuItem>
        <MenuItem value={"07"}>CFDI por Aplicación de Anticipo</MenuItem>
        <MenuItem value={"00"}>No aplica</MenuItem>
      </TextField>
      <TextField
        fullWidth
        size="small"
        label="Anticipos"
        variant="outlined"
        className="cel-13"
        select
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PaymentIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        // helperText={state.msolicitante}
        error={state.banticipos}
        onChange={({ target }) => {
          setState({
            ...state,
            anticipos: target.value,
            banticipos: false,
          });
        }}
        value={state.anticipos}
      >
        <MenuItem value={"SI"}>SI</MenuItem>
        <MenuItem value={"NO"}>NO</MenuItem>
      </TextField>
      <TextField
        fullWidth
        label="Folios de Anticipos"
        variant="outlined"
        className="cel-14"
        disabled={state.anticipos === "SI" ? false : true}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PaymentIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        helperText={state.mfolioanticipo}
        error={state.bfolioanticipo}
        onChange={({ target }) => {
          ValTextAndNumber("folioanticipo", target.value, onChange, true, 100);
        }}
        sx={{
          "& .MuiInputBase-root": {
            height: "40px", // Cambia el valor para ajustar la altura
          },
        }}
        value={state.folioanticipo}
      />
      <TextField
        fullWidth
        size="small"
        label="Nombre de Aval"
        variant="outlined"
        className="cel-15"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        // sx={{width:800}}
        type="text"
        // helperText={state.mnombre_aval}
        error={state.bnombre_aval}
        onChange={({ target }) => {
          ValSpecialCharacters(
            "nombre_aval",
            target.value,
            onChange,
            true,
            250
          );
        }}
        value={state.nombre_aval}
      />
      <TextField
        fullWidth
        size="small"
        label="Dirección de Aval"
        variant="outlined"
        className="cel-16"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <HomeIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        type="text"
        // helperText={state.mlugardeentrega}
        // sx={{marginLeft:10}}
        error={state.bdireccion_aval}
        onChange={({ target }) => {
          ValSpecialCharacters(
            "direccion_aval",
            target.value,
            onChange,
            true,
            500
          );
        }}
        value={state.direccion_aval}
      />

      {/* <div className="pedido-maquinaria-grid-container-footer">
        <div
          className="pedido-maquinaria-container-footer-guardar"
          onClick={() => onGuardar()}
        >
          GUARDAR
        </div>
      </div> */}
    </div>
  );
}
